<template>
  <div class="rich-wrapper form-group">
    <div ref="editor" />
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },
  watch: {
    value(value) {
      if (this.editor && this.editor.getLength() > 1) return
      const delta = this.editor.clipboard.convert(value)
      this.editor.setContents(delta, 'api')
    },
  },
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike', 'link'],
          [{ script: 'sub' }, { script: 'super' }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ color: [] }, { background: [] }],
        ],
      },
      theme: 'snow',
    })

    this.editor.on('text-change', () => this.update())
  },

  methods: {
    update() {
      const content = this.editor && this.editor.getLength() > 1 ? this.editor.root.innerHTML : ''
      this.$emit('input', content)
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-wrapper {
  display: block;

  & ::v-deep() {
    .ql-editor {
      min-height: 95px;
      max-height: 350px !important;
      overflow: auto;
      resize: vertical;
    }
  }
}

.ql-tooltip {
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/reused-components/rich-text-editor/RichTextEditor.vue